import React, { useMemo } from 'react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { cn } from '@/lib/utils';
import { useTimesheetForScreen } from '@/contexts/TimesheetContext';

interface RoleSelectorProps {
  value: number | undefined;
  onChange: (roleId: number | undefined) => void;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  className?: string;
}

export function RoleSelector({
  value,
  onChange,
  disabled = false,
  required = false,
  placeholder = 'Select role...',
  className,
}: RoleSelectorProps) {
  // Get roles from context - you'll need to add this to TimesheetContext
  // For now, we'll use a placeholder
  const roles = useMemo(() => {
    // TODO: Fetch roles from context or API
    // This is a placeholder - you'll need to implement role fetching
    return [];
  }, []);

  const handleValueChange = (newValue: string) => {
    if (newValue === 'none') {
      onChange(undefined);
    } else {
      onChange(parseInt(newValue, 10));
    }
  };

  return (
    <Select
      value={value?.toString() || 'none'}
      onValueChange={handleValueChange}
      disabled={disabled}
    >
      <SelectTrigger
        className={cn(
          required && !value && 'border-destructive focus:ring-destructive',
          className
        )}
      >
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent>
        {!required && (
          <SelectItem value="none">
            <span className="text-muted-foreground">No role selected</span>
          </SelectItem>
        )}
        {roles.length === 0 ? (
          <SelectItem value="loading" disabled>
            <span className="text-muted-foreground">No roles available</span>
          </SelectItem>
        ) : (
          roles.map((role: any) => (
            <SelectItem key={role.id} value={role.id.toString()}>
              {role.name}
            </SelectItem>
          ))
        )}
      </SelectContent>
    </Select>
  );
}
